import { render, staticRenderFns } from "./DetailTester.vue?vue&type=template&id=43d4cd1f"
import script from "./DetailTester.vue?vue&type=script&lang=js"
export * from "./DetailTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports